
// welcome
//------------------------------------------------------------
$(function(){

  if( $("body").is("#bureau") ){
    //from cmn-tag-list
    //------------------------------------------------------------
    $(".brMapSwitch").on('tap', function(){
      var that = $(this);
      var next = $(this).next();
      var ifr = next.find('iframe');
      next.not(":animated").slideToggle(300, function(){
        var src = ifr.data("src");
        ifr.attr("src","");
        ifr.attr("src",src);
        that.toggleClass("active");

        if( that.hasClass("active") ){
          $("a", that).text( that.data("close") );
        } else{
          $("a", that).text( that.data("open") );
        }
      });
    });

    // more btn
    //------------------------------------------------------------
    var moreTarget = $(".entry-body .econtents");
    var len = moreTarget.text().length;
    //

    if( len > 200 ){
      moreTarget.addClass("js-over");
      moreTarget.wrapInner('<span></span>');
      moreTarget.after('<p class="bt-more"><a href="javascript:void(0);">続きを表示</a></p>');
    }

    $(".entry-body .bt-more a").live('tap', function(){
      var that = $(this).parents().filter(".entry-body");
      $(this).remove();
      $(".js-over", that).removeClass("js-over");
    });

  }

  // if( $("body").is("#bureau.center") ){
  // }

});



// WEBPACK FOOTER //
// ./_src/js/cont/bureau.js